import React__default, { useEffect } from 'react';
import { Loader, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl, useDispatch } from '@grandvisionhq/state';
import { useAppointments } from '../hooks/useAppointments.js';
import AppointmentBody from './components/AppointmentBody/AppointmentBody.js';
import { appointmentsView } from '../../data-layer/appointments/actions.js';

const AppointmentsContainer = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const dispatch = useDispatch();
    const { data: appointments , loading , error  } = useAppointments();
    const routeLabel = getLabel(`account.menu.appointments`);
    useEffect(()=>{
        if (loading || appointments === null) {
            return;
        }
        dispatch(appointmentsView(appointments));
    }, [
        appointments,
        dispatch,
        loading
    ]);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small"
    }, routeLabel), loading ? /*#__PURE__*/ React__default.createElement(Loader, null) : error || appointments === null ? /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        message: getFormattedLabel('common.error.network')
    }) : // not loading and no error
    /*#__PURE__*/ React__default.createElement(AppointmentBody, {
        appointments: appointments
    }));
};
var AppointmentsContainer$1 = AppointmentsContainer;

export { AppointmentsContainer$1 as default };
//# sourceMappingURL=Appointments.js.map
